class ProductItemAddToCart extends Component {
    /**
     * @param {HTMLDivElement} el
     */
    constructor(el) {
        super(el);
        this.loginOpeners = this.$findAll('[data-button-login-opener]');

        if (this.loginOpeners.length > 0) {
            this.addLoginListenersOnly();
            return;
        }

        this.buttonBuy = this.$find('[data-button-buy]');
        this.variantId = this.$el.dataset.variantId;
        this.addToCartLink = this.$el.dataset.addToCartLink;

        this.addEventListeners();
    }

    openLogin() {
        EventBus.getInstance().dispatchEvent('showBasePopup', 'login-popup');
    }

    addLoginListenersOnly() {
        this.loginOpeners.forEach(btn => {
            btn.addEventListener('click', () => this.openLogin());
        });
    }

    addToCart() {
        const formData = new FormData();
        formData.append('id', this.variantId);
        formData.append('count', '1');
        formData.append('ajax', '1');

        EventBus.getInstance().dispatchEvent('showGlobalSpinner');
        fetch(this.addToCartLink, {
            method: 'POST', body: formData,
        })
            .then(response => response.json())
            .then(data => {
                if ('error' in data && data.error) {
                    alert(data.error);
                } else {
                    this.onCartAdded(data)
                }
            })
            .catch((error) => {
                console.error('Error:', error);
            })
            .finally(() => {
                EventBus.getInstance().dispatchEvent('hideGlobalSpinner');
            });
    }

    onCartAdded(data) {
        EventBus.getInstance().dispatchEvent('cartUpdated', data);
        if (data.remarketingCodes) {
            Util.appendToBody(data.remarketingCodes);
        }
    }

    onClick(e) {
        e.preventDefault();
        this.addToCart();
    }

    addEventListeners() {
        this.buttonBuy.addEventListener('click', e => this.onClick(e));
    }
}